module.exports = __webpack_public_path__ + "img/lincoln-Worth.bc15829b.png";